import { render, staticRenderFns } from "./TextHeadlinePrimary.vue?vue&type=template&id=25e604aa&scoped=true&"
var script = {}
import style0 from "./TextHeadlinePrimary.vue?vue&type=style&index=0&id=25e604aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e604aa",
  null
  
)

export default component.exports